module.exports = function(app) {
	app.service("aemContentResourceServices", ["$q", "services", "brand", "aemContent", function($q, services, brand, aemContent){

		// utilities
		var parseItem = function(obj) {
			var item;
			try {
				item = !!obj ? JSON.parse(obj.value) : null;
			} catch(response) {
				item = null;
			}
			return item;
		};

		// instantiation
		this.resources = {};
		var completeResourceList = {};

		// service methods
		this.getResourceIdListAsync = function(type) {
			var contentType = type || "Bluecore Resources";
			if (completeResourceList[type]) {
				return completeResourceList[type].promise;
			}
			completeResourceList[type] = $q.defer();
			var listOfIds = {};
			aemContent.getAll(contentType).then(function(response){
				for(var i in response) {
					if (!listOfIds[i]) {
						listOfIds[i] = true;
					}
				}
				completeResourceList[type].resolve(listOfIds);
			});
			return completeResourceList[type].promise;
		};

		this.updateResourcesAsync = function(listOfIds, filterFunction, type) {
			var defer = $q.defer(),
				self = this;
			var contentType = type || "Bluecore Resources";
			aemContent.getContent(listOfIds).then(function(qualifiedResponses){
				if(qualifiedResponses) {
					self.resources[contentType] = [];
					var ids = qualifiedResponses;
					for (var index in ids) {
						var item = parseItem(ids[index]);
						item["id"] = ids[index]["name"];
						if (filterFunction(item)) {
							self.resources[contentType].push(item);
						}
					}
				}

				defer.resolve(self.resources[contentType]);
			});

			return defer.promise;
		}
	}]);

};